function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5646 6.79102C14.5646 6.68789 14.4802 6.60352 14.3771 6.60352L12.8303 6.61055L10.5006 9.38789L8.17324 6.61289L6.62402 6.60586C6.5209 6.60586 6.43652 6.68789 6.43652 6.79336C6.43652 6.83789 6.45293 6.88008 6.48105 6.91523L9.53026 10.548L6.48105 14.1785C6.45273 14.2129 6.43702 14.2559 6.43652 14.3004C6.43652 14.4035 6.5209 14.4879 6.62402 14.4879L8.17324 14.4809L10.5006 11.7035L12.8279 14.4785L14.3748 14.4855C14.4779 14.4855 14.5623 14.4035 14.5623 14.298C14.5623 14.2535 14.5459 14.2113 14.5177 14.1762L11.4732 10.5457L14.5224 6.91289C14.5506 6.88008 14.5646 6.83555 14.5646 6.79102Z",
  fill: "#E64011"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 0C4.70156 0 0 4.70156 0 10.5C0 16.2984 4.70156 21 10.5 21C16.2984 21 21 16.2984 21 10.5C21 4.70156 16.2984 0 10.5 0ZM10.5 19.2188C5.68594 19.2188 1.78125 15.3141 1.78125 10.5C1.78125 5.68594 5.68594 1.78125 10.5 1.78125C15.3141 1.78125 19.2188 5.68594 19.2188 10.5C19.2188 15.3141 15.3141 19.2188 10.5 19.2188Z",
  fill: "#E64011"
});

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.3a1648ed.svg";
export { ForwardRef as ReactComponent };